// ========================================
// SERVIÇO DE IMPRESSÃO DE PROPOSTA
// src/services/impressaoService.js
// ========================================
// Serviço centralizado para impressão de propostas em PDF/A4

import React from 'react';
import ReactDOMServer from 'react-dom/server';
import ImpressaoProposta from '../components/ImpressaoProposta';

// Estilos CSS para impressão
const estilosImpressao = `
  @page {
    size: A4;
    margin: 0;
  }
  
  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
      margin: 0;
      padding: 0;
    }
    
    .print-container {
      width: 210mm !important;
      min-height: 297mm !important;
      page-break-after: always;
    }
    
    .no-print {
      display: none !important;
    }
  }
  
  * {
    box-sizing: border-box;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
  }
  
  table {
    border-collapse: collapse;
  }
`;

/**
 * Imprime a proposta em uma nova janela
 * @param {Object} dados - Dados da proposta
 * @param {Object} dados.pedido - Dados do pedido
 * @param {Object} dados.cliente - Dados do cliente
 * @param {Array} dados.forros - Lista de forros
 * @param {Array} dados.acessorios - Lista de acessórios
 * @param {Array} dados.produtosEspeciais - Lista de produtos especiais (Demais Produtos)
 * @param {Array|String} dados.formaPagamento - Formas de pagamento
 * @param {String} dados.observacao - Observações
 * @param {Number} dados.tabela - Número da tabela (1 ou 2)
 * @param {Number} dados.valorFrete - Valor do frete por tabela
 * @param {String} dados.cargoUsuario - Cargo do usuário logado
 */
export const imprimirProposta = (dados) => {
  const { pedido, cliente, forros, acessorios, produtosEspeciais = [], formaPagamento, observacao, tabela = 1, valorFrete = 0, cargoUsuario = '' } = dados;

  // Renderizar o componente para HTML
  const componenteHTML = ReactDOMServer.renderToStaticMarkup(
    <ImpressaoProposta
      pedido={pedido}
      cliente={cliente}
      forros={forros}
      acessorios={acessorios}
      produtosEspeciais={produtosEspeciais}
      formaPagamento={formaPagamento}
      observacao={observacao}
      tabela={tabela}
      valorFrete={valorFrete}
      cargoUsuario={cargoUsuario}
    />
  );

  // Criar HTML completo
  const htmlCompleto = `
    <!DOCTYPE html>
    <html lang="pt-BR">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Proposta ${pedido?.numero_proposta || ''} - Tabela ${tabela}</title>
      <style>${estilosImpressao}</style>
    </head>
    <body>
      ${componenteHTML}
      <script>
        window.onload = function() {
          setTimeout(function() {
            window.print();
          }, 500);
        };
      </script>
    </body>
    </html>
  `;

  // Abrir nova janela e imprimir
  const janelaImpressao = window.open('', '_blank', 'width=800,height=600');
  
  if (janelaImpressao) {
    janelaImpressao.document.write(htmlCompleto);
    janelaImpressao.document.close();
  } else {
    alert('Não foi possível abrir a janela de impressão. Verifique se o bloqueador de pop-ups está ativo.');
  }
};

/**
 * Gera o HTML da proposta para preview
 * @param {Object} dados - Dados da proposta
 * @returns {String} HTML da proposta
 */
export const gerarHTMLProposta = (dados) => {
  const { pedido, cliente, forros, acessorios, formaPagamento, observacao, tabela = 1 } = dados;

  return ReactDOMServer.renderToStaticMarkup(
    <ImpressaoProposta
      pedido={pedido}
      cliente={cliente}
      forros={forros}
      acessorios={acessorios}
      formaPagamento={formaPagamento}
      observacao={observacao}
      tabela={tabela}
    />
  );
};

export default {
  imprimirProposta,
  gerarHTMLProposta
};
